import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Select, MenuItem, FormControl } from "@mui/material";
import { ArrowDropDownRounded } from "@mui/icons-material";

export function SelectionBox({ handleSelect, value, options, ...rest }) {
    return (
        <Container>
            <StyledFormControl variant="outlined">
                <Select
                    onChange={handleSelect}
                    value={value}
                    IconComponent={ArrowDropDownRounded}
                    inputProps={{
                        ...rest
                    }}
                >
                    {options.map((opt, idx) => (
                        <MenuItem key={`${opt.value}-${idx}`} value={opt.value}>
                            {opt.display}
                        </MenuItem>
                    ))}
                </Select>
            </StyledFormControl>
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    max-width: 300px;
`;

const StyledFormControl = styled(FormControl)`
    width: 100%;
    background: white;
    border-radius: 5px;
`;

SelectionBox.propTypes = {
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            display: PropTypes.string
        })
    ),
    handleSelect: PropTypes.func
};
